import React, { Component } from 'react';
import {Row, Col, Modal} from 'react-materialize'
import ServiceItem from './ServiceItem.js'
import {connect} from 'react-redux';
import moment from 'moment'

class ServicesList extends Component {
  getServicesByGender(reqServiceType) {
    if (this.props.services.length > 0) {
      switch (reqServiceType) {
        case 'male':
          return this.props.services.filter(item => item.type === reqServiceType);
        case 'female':
          return this.props.services.filter(item => item.type === reqServiceType);
        case 'kid':
          return this.props.services.filter(item => item.type === reqServiceType);
        default:
        return this.props.services;
      }
    }
  }
  checkboxHandler = (value, quantity, check = true) => {
    this.props.checkboxHandler(value, quantity, check);
  }
  /*
  * returns false if date and time have not been choosen
  * if time and date have been selected, checks if time is valid.
  */
  getValidTime = (serviceTime) => {
    let validTime = false;
    if (this.props.selectedTime.length > 0 || this.props.selectedDate > 0) {
      validTime = this.checkTime(serviceTime);
    }
    return validTime;
  }

  /*
  * Check if there is enough time in the day to complete the service
  * based on the selected date and time
  * return true or false
  */
  checkTime = (serviceTime) => {
    let {businessHours, selectedDate, selectedTime} = this.props;
    // check if date and time have been selected
    if (!selectedDate || !selectedTime) {return}

    //loop through businessHours and return where = to selectedDate
    const selectedDayOfWeek = moment(selectedDate, ["MM-DD-YYYY", "YYYY-MM-DD"]).day(); // 4, thurs
    const currentDate = businessHours.find(item => item.day === selectedDayOfWeek)
    
    // get business hours
    const openTime = moment().set(currentDate.startTime) // 8:00 AM
    const closeTime = moment().set(currentDate.endTime) // 10:00 PM

    const requestedTime = moment(selectedTime, "HH:mm A");// 01:00 AM

    // add requestedTime to serviceTime
      //doesn't consider service time * quantity
    requestedTime.add(serviceTime, 'minutes');

    // and check if there is enough time or if business is open
      //remove colon, make string into number
    if(parseInt(requestedTime.format('HH:mm').replace(":", "")) > parseInt(closeTime.format('HH:mm').replace(":", ""))) {
      // console.log('Not enough Time left')
      return false
    }
    else if (parseInt(requestedTime.format('HH:mm').replace(":", "")) < parseInt(openTime.format('HH:mm').replace(":", ""))) {
      // console.log('Not open yet')
      return false
    }
    else {
      // console.log('Enough time');
      return true
    }
  }
  render() {
    return (
      <Row className={this.props.serviceOptions ? '' : 'hide'}>
          <h5>Choose type of service</h5>
          <span>*Times are estimates</span>
          <br />
          <span>*Greyed out services are not available at that selected date or time</span>

            <Col s={12}>
              <Col s={12} m={6}>
                <p><label>Female</label></p>
                <div className="collection">
                  { this.getServicesByGender('female') && this.getServicesByGender('female').map(item => {
                    const isTimeValid = this.getValidTime(item.time);
                    return <ServiceItem key={item.id} validTime={isTimeValid} item={item} checkboxHandler={this.checkboxHandler} />
                  })}
                </div>
              </Col>

              <Col s={12} m={6}>
                <p><label>Male</label></p>
                <div className="collection">
                  { this.getServicesByGender('male') && this.getServicesByGender('male').map(item => {
                    const isTimeValid = this.getValidTime(item.time);
                    return <ServiceItem key={item.id} validTime={isTimeValid} item={item} checkboxHandler={this.checkboxHandler} />
                  })}
                </div>
              </Col>

              <Col s={12} m={6}>
                <p><label>Kids</label></p>
                <div className="collection">
                { this.getServicesByGender('kid') && this.getServicesByGender('kid').map(item => {
                  const isTimeValid = this.getValidTime(item.time);
                  return <ServiceItem key={item.id} validTime={isTimeValid} item={item} checkboxHandler={this.checkboxHandler} />
                })}
              </div>
              </Col>
            </Col>
            <Modal id="modal1" header="Modal Header">
              Lorem ipsum dolor sit amet
            </Modal>
        </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    services: state.stylist.services,
    businessHours: state.appointment.businessHours
  }
}

export default connect(mapStateToProps)(ServicesList)
